export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-10.jpg'),
        title: '客户服务',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '提供出色的客户服务，客户体验决定了我们的价值',
      description: `<p style="font-size:1.05rem">在激烈的市场竞争中，客户服务己经成为企业在市场上面临的重要问题之一，让客户满意，把满足客户需求作为一切工作展开的目标和中心。如今，现代营销观念以着重考虑客户的需要，以客户为导向，企业通过客户的满意程度来获利。因此，无论是售前、售中还是售后，任何一家公司都需要专业的客服团队为用户的满意度保驾护航。</p>`
    },
    {
      title: 'Maesinfo拥有专业的客服人群，他们拥有',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-10.jpg')+`)"></span>
      <span class="list">
      <i></i>强大的心理素质、和品格素质来应对各种突发状况<br/>
      <i></i>拥有良好的语言表达能力、丰富的行业知识等专业技能<br/>
      <i></i>秉承着客户至上的服务理念，以寻求100%的客服满意度
      </span>`
    }
  ]
}
